import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlimtalkApiV2 } from '../../../lib/api/alimtalk/AlimtalkApiV2';
import { ErrorResponseType } from '../../../lib/utils/checkErrorResponse';
import toastMsg from '../../../lib/toastMsg';
import { AlimtalkCsvSampleResponse } from '../../../types/alimtalk/send';

/** 템플릿별 샘플 CSV 헤더 조회 — CSV 모드 전용, 파일 생성은 클라이언트 Blob */
export const useCsvSampleMutation = (): UseMutationResult<AlimtalkCsvSampleResponse, ErrorResponseType, number> =>
  useMutation({
    mutationFn: (templateId: number) => AlimtalkApiV2.getCsvSample(templateId),
    // 뮤테이션 에러는 전역 QueryCache.onError(쿼리 전용) 범위 밖 → 직접 토스트
    onError: (error) => {
      toastMsg.error('샘플 CSV를 불러오지 못했습니다.', error);
    },
  });
